<acl-ngx-page-header>
    <acl-ngx-page-header-section>
        <label>Advertiser</label>
        <h4>{{ advertiserInfo?.name }}</h4>
    </acl-ngx-page-header-section>
    <acl-ngx-page-header-section>
        <auto-complete [fetchData]="autoCompletetConfig.advertiserAutoCompletePromise" width="500px"
            [buttonTrigger]="true" [responseMapper]="autoCompletetConfig.responseMapper"
            (onSelect)="autoCompletetConfig.handleOnAdvertiserSelect($event)">
        </auto-complete>
    </acl-ngx-page-header-section>
</acl-ngx-page-header>
<div class="table-wrapper">
    <div>
        <acl-ngx-collapsible-nav>
            <acl-collapsible-nav-items-wrapper [collapsibleNavItems]="collapsibleItems">
            </acl-collapsible-nav-items-wrapper>
        </acl-ngx-collapsible-nav>
    </div>
    <div class="data-table">
        <div *ngIf="currentDashBoardPage === advertiserDashboardPage.Plans">
            <planner-list [advertiserInfo]="advertiserInfo"></planner-list>
        </div>
        <div *ngIf="currentDashBoardPage === advertiserDashboardPage.Deals">
            <deal-list [advertiserInfo]="advertiserInfo"></deal-list>
        </div>

    </div>
</div>
